import { QueryString } from '@libs/utils/url/url.interfaces';

export function parseQuery(query: string): QueryString {
    const decode = (value: string): string => decodeURIComponent(value.replace(/\+/g, '%20'));

    const params = new URLSearchParams(query.startsWith('?') ? query.slice(1) : query);

    return Array.from(params.entries()).reduce<QueryString>((acc, [key, value]) => {
        const decodedKey = decode(key);
        const decodedValue = decode(value);

        (acc[decodedKey] ??= []).push(decodedValue);
        return acc;
    }, {});
}

export function renderQuery(query: QueryString, prefixedByQuestionMark = false): string {
    const pairs = Object.entries(query).flatMap(([key, values]) => {
        if (!values || values.length === 0) {
            return [[key, '']];
        }
        return values.map((v) => [key, v]);
    });

    let queryString = new URLSearchParams(pairs as [string, string][]).toString();
    queryString = queryString.replace(/%20/g, '+');

    return prefixedByQuestionMark && queryString ? `?${queryString}` : queryString;
}
